"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ProZapLogo;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/* eslint-disable */

function ProZapLogo() {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    width: "140",
    height: "22",
    viewBox: "0 0 229 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M13.7359 36.8547C18.0888 36.8547 22.1999 35.0652 24.5214 32.2116L22.6352 30.3737C20.7489 32.6952 17.4117 34.2913 13.7359 34.2913C7.15813 34.2913 2.75685 30.0351 2.75685 23.409C2.75685 16.8796 7.35159 12.5751 13.9777 12.5751C17.2666 12.5751 20.5554 14.1228 22.3933 16.396L24.2796 14.5581C22.0548 11.8496 18.1855 10.0117 13.9777 10.0117C5.75552 10.0117 0 15.3319 0 23.409C0 31.5345 5.3686 36.8547 13.7359 36.8547Z",
      fill: "#4D009D"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M42.354 36.8547C45.5945 36.8547 49.3187 35.839 51.8337 32.9371V36.4678H54.4455V10.447H51.8337V13.8326C49.3187 10.979 45.4011 10.0117 42.2573 10.0117C34.7606 10.0117 29.2953 14.9934 29.2953 23.3123C29.2953 31.6312 34.4704 36.8547 42.354 36.8547ZM42.5959 34.2913C36.2599 34.2913 32.0521 30.0835 32.0521 23.3123C32.0521 16.5411 36.5501 12.5751 42.4991 12.5751C45.8847 12.5751 49.6089 13.9777 51.8337 17.1698V29.6482C49.7056 32.8887 46.0298 34.2913 42.5959 34.2913Z",
      fill: "#4D009D"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M62.8339 36.4678H65.4456V16.6378C67.6705 14.6548 71.0077 12.5751 74.9253 12.5751C80.0521 12.5751 83.1475 14.7999 83.1475 21.6195V36.4678H85.7592V21.426C85.7592 13.0587 81.9867 10.0117 75.3122 10.0117C71.5881 10.0117 67.9123 11.7529 65.4456 13.8326V10.447H62.8339V36.4678Z",
      fill: "#4D009D"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M104.77 36.8547C108.011 36.8547 111.735 35.839 114.25 32.9371V36.4678H116.862V10.447H114.25V13.8326C111.735 10.979 107.817 10.0117 104.674 10.0117C97.1769 10.0117 91.7116 14.9934 91.7116 23.3123C91.7116 31.6312 96.8868 36.8547 104.77 36.8547ZM105.012 34.2913C98.6763 34.2913 94.4685 30.0835 94.4685 23.3123C94.4685 16.5411 98.9665 12.5751 104.915 12.5751C108.301 12.5751 112.025 13.9777 114.25 17.1698V29.6482C112.122 32.8887 108.446 34.2913 105.012 34.2913Z",
      fill: "#4D009D"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M125.299 36.4678H128.007V0H125.299V36.4678Z",
      fill: "#4D009D"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M163.816 2.27344H150.177V36.468H156.077V26.6014H162.849C172.232 26.6014 177.213 22.587 177.213 14.2681C177.213 6.38452 172.57 2.27344 163.816 2.27344ZM162.607 21.4746H156.077V7.44857H163.332C168.604 7.44857 171.071 9.81849 171.071 14.4132C171.071 18.9596 168.411 21.4746 162.607 21.4746Z",
      fill: "#4D009D"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M181.678 36.468H187.385V23.7962C187.385 18.2825 190.481 15.3805 194.399 15.3805C195.463 15.3805 196.575 15.574 197.784 16.0093V9.91522C197.204 9.67339 196.382 9.57666 195.559 9.57666C191.787 9.57666 188.982 11.3178 187.24 13.7845V10.1571H181.678V36.468Z",
      fill: "#4D009D"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M214.572 37C223.181 37 228.985 31.5831 228.985 23.2642C228.985 15.042 223.181 9.57666 214.572 9.57666C205.963 9.57666 200.111 15.042 200.111 23.2642C200.111 31.5831 205.963 37 214.572 37ZM214.572 31.8733C209.591 31.8733 206.06 28.4393 206.06 23.2642C206.06 18.1858 209.591 14.7518 214.572 14.7518C219.554 14.7518 223.036 18.1858 223.036 23.2642C223.036 28.4393 219.554 31.8733 214.572 31.8733Z",
      fill: "#4D009D"
    })]
  });
}